import { render } from "./subholdings.vue?vue&type=template&id=6b4d2c42"
import script from "./subholdings.vue?vue&type=script&lang=js"
export * from "./subholdings.vue?vue&type=script&lang=js"

import "./subholdings.vue?vue&type=style&index=0&id=6b4d2c42&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__